export default __webpack_public_path__ + "img/chevron-down.a1c324d4.svg";